export function initializeTierPricing() {
    
    const tierBlocks = document.querySelector('.tiered-pricing-blocks');
    const tierBoxes = document.querySelectorAll('.tiered-pricing-block');
    const activeTierBox = document.querySelector('.tiered-pricing--active');
    const progressBar = document.querySelector('.tiered-pricing-progress');

    tierBoxes.forEach(gridItem => gridItem.addEventListener("click", updateProgress));

    const boxes = document.querySelectorAll(".custom-add-to-cart-wrap input[type='number']");
    const quantity = document.querySelectorAll(".ux-quantity__button");

    quantity.forEach(quantityBtn => quantityBtn.addEventListener("click", updateProgressData))
    boxes.forEach(input => input.addEventListener("keyup", updateProgressData))

    if (progressBar) {
        updateProgressbar();
    }
    

    function updateProgressData(el) {
        const progressBar = document.querySelector('.tiered-pricing-progress');
        const tierBlocks = document.querySelector('.tiered-pricing-blocks');
        const oneBlock = tierBlocks.children[0].offsetWidth;
        let maxWidth = progressBar.offsetWidth;
        let boxWidth = oneBlock;
        let countBox = tierBlocks.children.length;
        let countLine = (maxWidth - boxWidth) / (countBox - 1);

        progressBar.setAttribute('max', maxWidth);

        const quantity__input = document.querySelector(".custom-add-to-cart-wrap input[type='number']");
        const target = el.target; 

        let quantity = quantity__input.value;
        if (target.value == '+') {
            quantity = Number(quantity__input.value) + 1;
        } else if (target.value == '-') {
            quantity = Number(quantity__input.value) - 1;
        }

        const activeTierBox = document.querySelector('.tiered-pricing--active');
        const nextSibling = activeTierBox.nextElementSibling;

        const activeQuant = activeTierBox.getAttribute('data-tiered-quantity');
        const nextQuant = nextSibling.getAttribute('data-tiered-quantity');

        
        const diff = quantity - activeQuant;
        const top = nextQuant - activeQuant;

        const calc = diff / top;
       
        const index = [...activeTierBox.parentElement.children].indexOf(activeTierBox);
       
        progressBar.value = countLine * (index + calc) + ( boxWidth / 2 );
    }

    function updateProgress(el) {
        const progressBar = document.querySelector('.tiered-pricing-progress');
        const oneBlock = el.target.offsetWidth;
        let boxWidth = oneBlock;
        let maxWidth = progressBar.offsetWidth;
        let countBox = tierBlocks.children.length;
        let countLine = (maxWidth - boxWidth) / (countBox - 1);

        progressBar.setAttribute('max', maxWidth);
        const activeTierBox = document.querySelector('.tiered-pricing--active');

        const target = el.target;
   
        const index = [...target.parentElement.children].indexOf(target);
       
        progressBar.value = countLine * index + ( boxWidth / 2 );
    }

    function updateProgressbar()
    {
        const progressBar = document.querySelector('.tiered-pricing-progress');
        const oneBlock = document.querySelector('.tiered-pricing-block').offsetWidth;
        let maxWidth = progressBar.offsetWidth;
  
        progressBar.setAttribute('max', maxWidth);
        progressBar.value = oneBlock / 2;
    }
}